import { cx } from '@twind/core';

import { SwitchProps } from './Switch.types';

const Switch = ({ className, ...props }: SwitchProps) => {
  return (
    <input
      type="checkbox"
      {...props}
      className={cx(
        "flex flex-none w-[45px] h-[28px] appearance-none bg-[#B0B0B0] p-[3px] rounded-[24px] after:content-[''] after:block after:w-[22px] after:h-[22px] after:bg-[white] after:ml-0 after:rounded-[50%] checked:after:ml-auto",
        className
      )}
    />
  );
};

export default Switch;
